// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Logo-style__wrapper__fdc13700","icon":"Logo-style__icon__fdc13700"};